export default {"src":"/_next/static/media/icon_header_z.4578f5a1.svg","height":20,"width":21,"blurWidth":0,"blurHeight":0};